module.exports = __webpack_public_path__ + "img/pinterest.dc4cbb40.svg";